import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/layout/AppLayout.vue'
import { useAuthStore } from '@/modules/auth/stores/auth.store'
import { authModuleRoute } from '@/modules/auth/auth.routes'
import { mapModuleRoute } from '@/modules/map/map.routes'
import { homeModuleRoute } from '@/modules/home/home.routes'
import { electionModuleRoute } from '@/modules/election/election.routes'
import { pollingCenterModuleRoute } from '@/modules/polling-center/polling-center.routes'
import { constituencyMapModuleRoute } from '@/modules/constituency/constituency-map.routes'
import { primariesModuleRoute } from '@/modules/primaries/primaries.routes'
import { primariesModuleRoute2026 } from '@/modules/primaries-2026/primaries.routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: AppLayout,
      children: [
        homeModuleRoute,
        electionModuleRoute,
        pollingCenterModuleRoute,
        {
          path: 'login-index',
          name: 'auth.login.index',
          component: () => import('@/modules/auth/views/LoginIndex.vue')
        }
      ]
    },
    authModuleRoute,
    mapModuleRoute,
    constituencyMapModuleRoute,
    primariesModuleRoute,
    primariesModuleRoute2026
  ]
})

router.beforeEach(async (to) => {
  const publicPages = ['/auth/login']
  const authRequired = !publicPages.includes(to.path)
  const authStore = useAuthStore()

  if (authRequired && authStore.isLoggedInExpired) {
    authStore.returnUrl = to.fullPath
    authStore.logout()
  }
})

export default router
